<!-- <app-menu-form [url]="url$|async" [menuDisplay]="menuDisplay" [dispositifFinancement]="dispositifFinancement$ | async"
    [dispositifRemboursement]="dispositifRemboursement$ | async" (menuClick)="menuClick($event)"
    (closeMenu)="closeMenu()"></app-menu-form> -->

<app-menu-form [url]="url$|async" [menuDisplay]="menuDisplay" [dispositifFinancement]="dispositifFinancement$ | async"
    [dispositifRemboursement]="dispositifRemboursement$ | async" (closeMenu)="closeMenu()"
    (subMenuclicked)="menuClick($event)" [isLoggedIn]="isLoggedIn"></app-menu-form>